import { render, staticRenderFns } from "./DeleteExcludedUser.vue?vue&type=template&id=3ca40f01&scoped=true"
import script from "./DeleteExcludedUser.vue?vue&type=script&lang=js"
export * from "./DeleteExcludedUser.vue?vue&type=script&lang=js"
import style0 from "./DeleteExcludedUser.vue?vue&type=style&index=0&id=3ca40f01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca40f01",
  null
  
)

export default component.exports